<!-- Container -->
<div class="kt-container-fixed">
	<div class="flex flex-col items-center justify-center gap-3 py-5 md:flex-row md:justify-between">
		<div class="order-2 flex flex-col items-center gap-0.5 text-sm font-normal md:flex-row md:gap-2 md:order-1">
			<span class="text-muted-foreground">&#169; {{ currentYear }} {{ theme()?.name }}.</span>
			<span class="text-muted-foreground">Todos os direitos reservados.</span>
		</div>
		<div class="order-2 flex gap-5 text-sm font-normal md:order-1">
			@for (badge of badges(); track badge.src) {
				@if (badge.url) {
					<a [href]="badge.url" target="_blank" rel="noopener noreferrer">
						<img class="h-[35px]" [src]="badge.src" [alt]="badge.name ?? 'Badge'" />
					</a>
				} @else {
					<img class="h-[35px]" [src]="badge.src" [alt]="badge.name ?? 'Badge'" />
				}
			}
		</div>
	</div>
</div>
<!-- End of Container -->
